import api from '@/api/Api'

export const state = {
  currentRegion: null,
  regions: []
}

export const getters = {
  currentRegion(state) {
    return state.currentRegion
  },
  regions(state) {
    return state.regions
  }
}

export const mutations = {
  SET_CURRENT_REGION(state, newValue) {
    state.currentRegion = newValue
  },
  SET_REGIONS(state, newValue) {
    state.regions = newValue
  }
}
export const actions = {
  async fetchAllRegions({ commit }) {
    const response = await api.getAllRegion()
    commit('SET_REGIONS', response.data.data)
    return response.data.data
  },
  setRegion({ commit, state, rootState }, region) {
    return api.updateUser(region).then(response => {
      return response
    })
  }
}



// WEBPACK FOOTER //
// ./src/state/modules/region.js